const data = {
  primary: '#0c7dba',
  secondary: '#e8eef9',
  header: '#003882',
  footer: '#003882',
  questionnairyMain: '#003882'
}

export default data
